// extracted by mini-css-extract-plugin
export var root = "_zs-0";
export var scroll = "_zs-1";
export var thumb = "_zs-3";
export var track = "_zs-2";